import React, { useEffect, useRef, useState } from "react"
import { Stream } from "@cloudflare/stream-react"
import { useOnScreen } from "../hooks"

const isBrowser = typeof window !== "undefined"

const StreamVideo = ({ src, poster }) => {
  const videoRef = useRef(null)
  const containerRef = useRef()
  const isOnScreen = useOnScreen(containerRef, "200px")
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [isOnScreen])

  const pauseOthers = () => {
    if (!isBrowser) return
    const streams = document.getElementsByTagName("stream")
    if (streams && streams.length) {
      Array.prototype.forEach.call(streams, stream => {
        if (stream !== videoRef.current) {
          if (typeof stream.pause === "function") {
            stream.pause()
          }
        }
      })
    }
  }

  return (
    <div
      className="video-stream-container relative w-full pt-[56.25%]"
      ref={containerRef}
    >
      <div className="absolute top-0 left-0 w-full h-[100%]">
        {src && poster && isVisible ? (
          <Stream
            src={src}
            poster={poster}
            streamRef={videoRef}
            key={src}
            controls
            onPlay={pauseOthers}
            onPlaying={pauseOthers}
            responsive={true}
          />
        ) : (
          <div className="bg-white w-full flex items-center justify-center h-[100%]">
            <p className="font-syne--22">Invalid video</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default StreamVideo
